import { getAuth } from "firebase/auth";
import { getApiUrl } from "./config";

const base = () => `${getApiUrl()}/leases`;

async function authHeaders() {
  const user = getAuth().currentUser;
  const token = user ? await user.getIdToken() : null;
  return {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
  };
}

export async function listLeases() {
  const res = await fetch(base(), { headers: await authHeaders() });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Failed to load leases (${res.status})`);
  }
  const data = await res.json();
  return data.leases || [];
}

export async function getLease(id) {
  const res = await fetch(`${base()}/${id}`, { headers: await authHeaders() });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Failed to load lease (${res.status})`);
  }
  return res.json();
}

export async function createLease(leaseData) {
  const res = await fetch(base(), {
    method: "POST",
    headers: await authHeaders(),
    body: JSON.stringify(leaseData),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Failed to create lease (${res.status})`);
  }
  return res.json();
}

export async function updateLease(id, updates) {
  const res = await fetch(`${base()}/${id}`, {
    method: "PUT",
    headers: await authHeaders(),
    body: JSON.stringify(updates),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Failed to update lease (${res.status})`);
  }
  return res.json();
}

export async function deleteLease(id) {
  const res = await fetch(`${base()}/${id}`, {
    method: "DELETE",
    headers: await authHeaders(),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Failed to delete lease (${res.status})`);
  }
  return res.json();
}

/** Creates token if needed; returns public tenant intent URL. */
export async function getTenantIntentLink(leaseId) {
  const res = await fetch(
    `${base()}/${encodeURIComponent(leaseId)}/tenant-intent-link`,
    {
      method: "POST",
      headers: await authHeaders(),
    }
  );
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(
      err.error || `Could not create intent link (${res.status})`
    );
  }
  return res.json();
}

/** After a direct Firestore lease write, re-run vacancy listing draft if applicable. */
export async function reconcileVacancyDraft(leaseId) {
  const res = await fetch(
    `${base()}/${encodeURIComponent(leaseId)}/reconcile-vacancy-draft`,
    {
      method: "POST",
      headers: await authHeaders(),
    }
  );
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Reconcile failed (${res.status})`);
  }
  return res.json();
}
